/**
 * @generated SignedSource<<978b4fd61441af7f9015aa4016227bac>>
 * @relayHash cbde2beb7f458203aa5f40e2c0461850
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8f0a16320822febb18840c804d0537c599fac2af461a838169f297593c28ed6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d8f0a16320822febb18840c804d0537c599fac2af461a838169f297593c28ed6",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
